const FIREBASE_KEYS = {
  TLAND_ENDPOINT: process.env.REACT_APP_FIREBASE_TLAND_ENDPOINT,
};

const API_URL = process.env.REACT_APP_API_URL;
const MAP_URL = process.env.REACT_APP_CARDANO_MAP_URL;
const CONFIG_COLLECTION = true;
const PLOT_IMAGE_PATH = process.env.REACT_APP_PLOT_IMAGE_PATH;
const DEED_IMG_URL = process.env.REACT_APP_DEED_IMG_URL;
const ELAPSED_TIME = 20;
const IMG_URL = process.env.REACT_APP_IMG_URL;
const ENV = process.env.REACT_APP_ENV;
const DEED_POLICY_ID = process.env.REACT_APP_DEED_POLICY_ID;

export const pubKeyDev1 =
  "\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoVqF0jGo1qpuhVB316Qa\nY9ck9S7w7fXsUqpkb/UZDQ8Rwf/Z0btie+5NT7DlXQz1T0uBtBg0zisL4j2+T46T\nLYpLdMzVfRCxLgrI/Tm4I+CRcfSl6IQ+JwjaxKb5I0bu4xTVXHveh+NmKgGXR5Ah\nGpaWJqZJRhrrQczHkbqgYnysoc4ANm4j1JVvE9VUZzQZ9PblI7g9n5GLej18w+ey\nYZwMiKGQj9VgP8Rulp6IwWygeSiajwxYd4NvDfJjPT8rirEJ0KcxyXZdVNPD0DKT\n584uWPBGAcUPqxI2w8389U61MbJpXX6gXrVh/wZ/A5eESHjtESMuWetfKRcjHQ1N\nxwIDAQAB\n";
export const decKeyDev1 = "zc6vIgYYL0KWcJ";
export const pubKeyProd1 =
  "\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1lH0ZA0UDFPhaTDcRCyM\nhF+1z5v1cGSBDC2EXlS655IM2bQ/FyVNaAZheRymt1jdeJoS0DqU5UpL+uFTafyi\nm7u8Akt5ZTWNTZtsct2jp1nqeYSpTXODRdj/uKOz2taIyp/HWMnho64ixx3RCnoH\nHIqQSRo7zPpDr4u0EmbGH93IJ5ME0VbBtPlast3xYHD9s5J1K897/Ieba9jKN9su\nNh4qflCmaoJo8LG/xRD3hmU07bV4vr9mepoth25xoMQVAMfyYJd5JRTdMq4m7yCX\nOmcIJrZ2GPr9OJ15ZMB96XYEDf0CaxkLQ/ybMk+KXuBAd3HwV3n+kq8tnhSJ4Gkh\nWQIDAQAB\n";
export const decKeyProd1 = "bwN6zfvm0+HyE+er";
const Config = {
  FIREBASE_KEYS,
  API_URL,
  MAP_URL,
  // CARDANO_POLICY_ID_HEX,
  // CARDANO_TRANSACTION_HASH_LINK,
  CONFIG_COLLECTION,
  PLOT_IMAGE_PATH,
  ELAPSED_TIME,
  DEED_IMG_URL,
  IMG_URL,
  ENV,
  DEED_POLICY_ID,
};

export const CHAIN = {
  EITH: "ETH",
  CARDANO: "CARDANO",
};

export const PAYMENT_SUPPORT = {
  EITH: "ETH",
  TVK: "TVK",
  BOTH: "BOTH",
};
export const SUPPORTED_CHAINS = ["0x13881", "0x1", "0x5", 80001, 1, 5];

export const INVENTORY_TYPE = {
  PLOT: "plot",
  CONDO: "CONDO",
};
export const CONNECTORS = {
  INJECTED: "injected",
  WALLET_CONNECT: "wallet_connect",
};
export const PLOT_BLOCKCHAIN_CATEGORY = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
  GIGA: "GIGA",
};
export const PLOT_STATUS = {
  AVAILABLE: "AVAILABLE",
  LOCKED: "LOCKED",
  PROCESSING: "PROCESSING",
  SOLD: "SOLD",
};
export default Config;
